import { UiOption } from '@/lib/helpers';
import { ControlActionValue } from '@/lib/models/policy-model/controls';
import { getFormattedUiOptions } from '../select/helpers';
import { ClassifierEntity } from '@/lib/models/policy-model/classifier-controls';
import { FormHandle } from '@/hooks/use-form-handle.hook';
import { ClassifierModel } from '@/lib/models/classifier';
import { PolicyModel } from '@/lib/models/policy-model/policy.model';
import { cloneDeep } from 'lodash';

export interface ClassifierControlListProps {
  formHandle: FormHandle<PolicyModel>;
  readonly: boolean;
  defaultPolicy?: PolicyModel;
  withNotSet?: boolean;
  classifiers: ClassifierModel[];
  refetch: () => Promise<unknown>;
}

export const updateClassifierAction = (
  entities: ClassifierEntity[],
  classifierId: string,
  action: ControlActionValue
): ClassifierEntity[] => {
  const updated = cloneDeep(entities);
  const entityIndex = updated.findIndex(({ classifierId: id }) => id === classifierId);

  if (entityIndex > -1) {
    if (action) {
      updated[entityIndex].action = action;
    } else {
      updated.splice(entityIndex, 1);
    }
  } else if (action) {
    updated.push({ classifierId, action });
  }

  return updated;
};

export const getClassifierItemOptions = (
  actionOptionsMap: Map<string, UiOption[]>,
  classifierId: string,
  defaultPolicyAction?: ControlActionValue
): UiOption[] => {
  const baseOptions = (actionOptionsMap.get(classifierId) || []).map((option) => {
    if (option.meta?.header) {
      return option;
    }

    return {
      ...option,
      meta: { ...option.meta, isDefaultPolicy: option.value === defaultPolicyAction },
    };
  });

  return getFormattedUiOptions(baseOptions);
};
